import { render, staticRenderFns } from "./PJProposalInsureds.vue?vue&type=template&id=a1a6dbd8"
import script from "./PJProposalInsureds.vue?vue&type=script&lang=js"
export * from "./PJProposalInsureds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports